module.exports = {
    BASE_URL: BASE_URL,
    auth: BASE_URL + "auth/",
    clearToken: BASE_URL + "auth/clear-token/",
    authCheck: BASE_URL + "auth/check/",
    authCheckWithToken: BASE_URL + "auth/check-with-token/",
    authLogout: BASE_URL + "auth/logout/",
    authGetPermissions: BASE_URL + "auth/permissions/",
    dashboard: {
        stats: BASE_URL + "dashboard/",
    },
    resources: {
        plantilla: BASE_URL + "static/resources/plantilla-de-ejemplo.docx"
    },
    usuarios: {
        perfil: BASE_URL + "usuarios/perfil/",
        usuarios: BASE_URL + "usuarios/usuarios/",
        permisos: BASE_URL + "usuarios/permisos/",
		permisos_all: BASE_URL + "usuarios/permisos/all/",
        grupos: BASE_URL + "usuarios/grupos/",
        notificacion: BASE_URL + "usuarios/notificacion"
    },
    configuracion: {
        tiposdedocumento: BASE_URL + "configuracion/tiposdedocumento/",
        rubros: BASE_URL + "configuracion/rubros/",
        encabezados: BASE_URL + "configuracion/encabezados/",
        tiposdecomprobante: BASE_URL + "configuracion/tiposdecomprobante/",
        estadocivil: BASE_URL + "configuracion/estadocivil/",
        vencimiento: BASE_URL + "configuracion/vencimiento/",
        vencimientoList: BASE_URL + "configuracion/vencimiento/list/",
    },
    config: {
        default: BASE_URL + "config/default/"
    },
    geograficas: {
        localidades: BASE_URL + "geograficas/localidades/",
        provincias: BASE_URL + "geograficas/provincias/",
    },
    proveedores: {
        proveedores: BASE_URL + "proveedores/",
        proveedores_select: BASE_URL + "proveedores/select/",
        documento: BASE_URL + "proveedores/$id_proveedor/documento/$id_archivo/",
    },
    loteos: {
        loteos: BASE_URL + "loteos/loteos/",
        loteos_select: BASE_URL + "loteos/loteos/select/",
        tipoloteos: BASE_URL + "loteos/tipoloteos/",
        lotes: BASE_URL + "loteos/$id/lotes/",
        lote: BASE_URL + "loteos/$id_loteo/lotes/",
        loteDatosVenta: BASE_URL + "loteos/$id/lotes/datosventa/",
        lotesSelect: BASE_URL + "loteos/$id/lotes/select/",
        documento: BASE_URL + "loteos/$id_loteo/documento/$id_archivo/",
        plano: BASE_URL + "loteos/$id_loteo/plano/$id_archivo/",
        plantilla: BASE_URL + "loteos/$id_loteo/plantilla/$id_archivo/",
        reporte: BASE_URL + "loteos/reportes/$id_loteo/",
    },
    obras: {
        obras: BASE_URL + "obras/obras/",
        obras_select: BASE_URL + "obras/obras/select/",
        contrato: BASE_URL + "obras/obras/$obra_id/contrato/",
        gastos: BASE_URL + "obras/gastos/",
        gastosRecibo: BASE_URL + "obras/gastos/recibo/",
    },
    inversionista: {
        disponibilidad: BASE_URL + "inversionista/loteos/disponibilidad",
        inversionista: BASE_URL + "inversionista/inversionista/",
        movimientos:{
            totalizadores: BASE_URL + "inversionista/movimientos/totalizadores",
            list :  BASE_URL + "inversionista/movimientos/",
            export:  BASE_URL + "inversionista/movimientos/export/",
        },
        deudas:{
            list :  BASE_URL + "inversionista/deudas/",
            export:  BASE_URL + "inversionista/deudas/export/",
        },
        loteos: BASE_URL  + "inversionista/loteos/",
        grafico: BASE_URL + "inversionista/grafico/",
    },
    vendedores: {
         vendedores:BASE_URL + "vendedores/vendedores/",
         usuarios:BASE_URL + "vendedores/usuarios/",
         lotes: BASE_URL + "vendedores/lotes/$id/",
    },
    container: BASE_URL + "container/",
    clientes: {
        clientes: BASE_URL + "clientes/",
        select: BASE_URL + "clientes/select/",
        clientesdocumentos: BASE_URL + "clientes/$id_cliente/documento/$id_archivo/",
        movimientos: BASE_URL + "clientes/movimientos/",
    },
    geograficas: {
        provincias: BASE_URL + "geograficas/provincias/",
        localidades: BASE_URL + "geograficas/localidades/",
        nacionalidades: BASE_URL + "geograficas/nacionalidades/",
        sucursales: BASE_URL + "geograficas/sucursales/",
    },
    ventas: {
        consultas: BASE_URL + "ventas/consultas/",
        ventas: BASE_URL + "ventas/ventas/",
        firmar: BASE_URL + "ventas/ventas/$id/firmar/",
        escalartitularidad: BASE_URL + "ventas/ventas/$id/escalartitularidad/",
        rescindir: BASE_URL + "ventas/ventas/$id/rescindir/",
        cuotas: BASE_URL + "ventas/ventas/$id/cuotas/",
        cuota: BASE_URL + "ventas/ventas/$id/cuotas/",
        editcuotas: BASE_URL + "ventas/ventas/$id/editcuotas/",
        recibo: BASE_URL + "ventas/reportes/ventas/$id_loteo/cuotas/",
        documento: BASE_URL + "ventas/ventas/$id_venta/documento/$id_archivo/",
        plantilla: BASE_URL + "ventas/ventas/$id_venta/plantilla/$id_archivo/",
        calculos: BASE_URL + "ventas/ventas/calculos/",
        listCuotas: BASE_URL + "ventas/ventas/cuotas/",
        listCuotasTotal: BASE_URL + "ventas/ventas/cuotastotal/",
        ajustarDesactualizadas: BASE_URL + "ventas/ventas/cuotas/ajustar-desactualizadas/",
        previewAjustarDesactualizadas: BASE_URL + "ventas/ventas/cuotas/ajustar-desactualizadas/preview",
        actualizarValores: BASE_URL + "ventas/ventas/cuotas/actualizar-valores/",
        previewActualizarValores: BASE_URL + "ventas/ventas/cuotas/actualizar-valores/preview",
        reservas: BASE_URL + "ventas/reservas/",
    },
    servicios: {
        consultas: BASE_URL + "servicios/consultas/",
        servicios: BASE_URL + "servicios/servicios/",
        firmar: BASE_URL + "servicios/servicios/$id/firmar/",
        rescindir: BASE_URL + "servicios/servicios/$id/rescindir/",
        escalartitularidad: BASE_URL + "servicios/servicios/$id/escalartitularidad/",
        cuotas: BASE_URL + "servicios/servicios/$id/cuotas/",
        cuota: BASE_URL + "servicios/servicios/$id/cuotas/",
        editcuotas: BASE_URL + "servicios/servicios/$id/editcuotas/",
        recibo: BASE_URL + "servicios/reportes/servicios/$id_loteo/cuotas/",
        documento: BASE_URL + "servicios/servicios/$id_servicio/documento/$id_archivo/",
        plantilla: BASE_URL + "servicios/servicios/$id_servicio/plantilla/$id_archivo/",
        calculos: BASE_URL + "servicios/servicios/calculos/",
        listCuotas: BASE_URL + "servicios/servicios/cuotas/",
        listCuotasTotal: BASE_URL + "servicios/servicios/cuotastotal/",
        ajustarDesactualizadas: BASE_URL + "servicios/servicios/cuotas/ajustar-desactualizadas/",
        previewAjustarDesactualizadas: BASE_URL + "servicios/servicios/cuotas/ajustar-desactualizadas/preview",
        actualizarValores: BASE_URL + "servicios/servicios/cuotas/actualizar-valores/",
        previewActualizarValores: BASE_URL + "servicios/servicios/cuotas/actualizar-valores/preview",
        reservas: BASE_URL + "servicios/reservas/",
        deudasReportes: BASE_URL + "servicios/reportes/deudas/",
        listDeudasReportes: BASE_URL + "servicios/reportes/listdeudas/",
    },
    escrituras: {
        consultas: BASE_URL + "escrituras/consultas/",
        escrituras: BASE_URL + "escrituras/escrituras/",
        firmar: BASE_URL + "escrituras/escrituras/$id/firmar/",
        rescindir: BASE_URL + "escrituras/escrituras/$id/rescindir/",
        cuotas: BASE_URL + "escrituras/escrituras/$id/cuotas/",
        cuota: BASE_URL + "escrituras/escrituras/$id/cuotas/",
        editcuotas: BASE_URL + "escrituras/escrituras/$id/editcuotas/",
        recibo: BASE_URL + "escrituras/reportes/escrituras/$id_loteo/cuotas/",
        documento: BASE_URL + "escrituras/escrituras/$id_servicio/documento/$id_archivo/",
        plantilla: BASE_URL + "escrituras/escrituras/$id_servicio/plantilla/$id_archivo/",
        calculos: BASE_URL + "escrituras/escrituras/calculos/",
        listCuotas: BASE_URL + "escrituras/escrituras/cuotas/",
        listCuotasTotal: BASE_URL + "escrituras/escrituras/cuotastotal/",
        ajustarDesactualizadas: BASE_URL + "escrituras/escrituras/cuotas/ajustar-desactualizadas/",
        previewAjustarDesactualizadas: BASE_URL + "escrituras/escrituras/cuotas/ajustar-desactualizadas/preview",
        actualizarValores: BASE_URL + "escrituras/escrituras/cuotas/actualizar-valores/",
        previewActualizarValores: BASE_URL + "escrituras/escrituras/cuotas/actualizar-valores/preview",
        reservas: BASE_URL + "escrituras/reservas/",
        deudasReportes: BASE_URL + "escrituras/reportes/deudas/",
        listDeudasReportes: BASE_URL + "escrituras/reportes/listdeudas/",
    },
    reportes: {
        reportes: BASE_URL + "reportes/",
    },
    deudas_reportes: BASE_URL + "reportes/deudas/",
    deudas_reportes_ventas: BASE_URL + "reportes/deudas/ventas/",
    users_select: BASE_URL + "ventas/user/select/",
    escribania: {
        escribania: BASE_URL + "escribania/",
        documento: BASE_URL + "escribania/$id_escribania/documento/$idDatos/$tipo/",
        documentoPropietario: BASE_URL + "escribania/$id_escribania/documentopropietario/$id/",
        reporte: BASE_URL + "escribania/reportes/$id/"
    },
    mails: {
        config: BASE_URL + "configuracion/mails/",
        plantillas: BASE_URL + "mails/plantillas/",
        casillas: BASE_URL + "mails/casillas/",
        bitacora: BASE_URL + "mails/bitacora/",
    },
    calendar: {
        tipoEventos: BASE_URL + "tipoeventos/",
        eventosCalendar: BASE_URL + "eventoscalendar/",
        eventosUsuario: BASE_URL + "eventoscalendar/usuario/",
    },
    caja: {
        caja: BASE_URL + "caja/caja/",
        usuarioCaja: BASE_URL + "caja/usuarioCaja/",
        movimientosCaja: BASE_URL + "caja/movimientoscaja/",
        asignarCuentas: BASE_URL + "caja/movimientoscaja/asignarCuentas/",
        cuentas: BASE_URL + "caja/cuentas/",
        configuracionCuentas: BASE_URL + "caja/configuracioncuentas/",

        movimientosAgrupados: BASE_URL + "caja/movimientoscaja/agrupados/"
    },
    monedas: {
        monedas: BASE_URL + "monedas/monedas/",
        historial: BASE_URL + "monedas/historial/",
    },
    recibos: {
        firmas: BASE_URL + "recibos/firmas/",
        configuracion: BASE_URL + "recibos/configuracion/",
    },
    MailsDeudores:BASE_URL + "clientes/mailsDeudores/",
    EnviarMailMorosos:BASE_URL + "clientes/sendMailDeudores/",

}



// WEBPACK FOOTER //
// ./src/api/api.js